import { faSpinner } from "@fortawesome/free-solid-svg-icons/faSpinner";

export const LOADING_ICON = faSpinner;
